import { v4 as uuidv4 } from 'uuid';

export const generate_uuid = () => {
  return uuidv4();
};
